
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/post/[postid]",
      function () {
        return require("private-next-pages/post/[postid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/post/[postid]"])
      });
    }
  